<div id="login-bg" class="flex flex-col justify-between items-center min-h-screen p-4 sm:p-6 lg:p-8">
  <!-- Central Card -->
  <main class="w-full max-w-md my-auto animate-slide-up">
    <div class="bg-white rounded-3xl p-8 sm:p-10 shadow-2xl">
      <!-- Header with Logo, Title and Subtitle in Juboo brand colors -->
      <div class="flex flex-col items-center text-center mb-6">
        <div class="mb-4 flex items-center justify-center">
          <img src="assets/logo-juboo.png" alt="Juboo" class="h-12 sm:h-14 w-auto object-contain" />
        </div>
        <h1 class="text-2xl sm:text-3xl font-extrabold text-primary tracking-tight">
          {{ 'LOGIN.TITLE' | translate }}
        </h1>
        <p class="text-xs sm:text-sm text-stone-500 mt-1.5 max-w-xs font-normal">
          {{ 'LOGIN.SUBTITLE' | translate }}
        </p>
      </div>

      <!-- Global Error Alert -->
      @if (errorMsg) {
        <div class="mb-3 py-2 px-3 bg-rose-50 border border-rose-200 text-rose-700 text-xs font-medium rounded-lg flex items-center gap-2 animate-fade-in shadow-xs">
          <svg class="w-3.5 h-3.5 shrink-0 text-rose-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span class="flex-1 font-semibold">{{ errorMsg }}</span>
        </div>
      }

      <form [formGroup]="credentials" (submit)="onSubmit($event)">
        <!-- Username/Email Field with app-input -->
        <app-input
          id="username"
          type="email"
          icon="user"
          [label]="'LOGIN.EMAIL_LABEL' | translate"
          formControlName="username"
          placeholder="votre.email@domaine.com"
          autocomplete="username"
          [error]="emailError"
        ></app-input>

        <!-- Password Field with app-input -->
        <app-input
          id="password"
          type="password"
          icon="lock"
          [label]="'LOGIN.PASSWORD_LABEL' | translate"
          formControlName="password"
          placeholder="••••••••"
          autocomplete="current-password"
          [error]="passwordError"
        >
          <a
            label-suffix
            routerLink="/forgot-password"
            class="text-xs font-semibold text-secondary hover:text-secondary-600 transition"
          >
            {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
          </a>
        </app-input>

        <!-- Submit Button (Centered) -->
        <div class="mt-4 flex justify-center">
          <app-button
            type="submit"
            variant="primary"
            size="md"
            [loading]="loading"
            [disabled]="loading"
            customClass="px-8 shadow-xs"
          >
            <span class="leading-none">{{ 'LOGIN.LOGIN_BUTTON' | translate }}</span>
            <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </app-button>
        </div>
      </form>
    </div>
  </main>

  <!-- Footer -->
  <footer class="w-full text-center py-4 text-xs text-white/70 font-medium select-none">
    <div class="flex items-center justify-center gap-2">
      <svg class="w-3.5 h-3.5 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
      <span>Plateforme sécurisée &bull; Juboo &copy; {{ currentYear }}</span>
    </div>
  </footer>
</div>
